module.exports = __webpack_public_path__ + "static/img/szafa_dso_24.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/produkty/szafa_dso_24.svg
// module id = Gz6a
// module chunks = 0